<template>
  <div>
    <pdf-preview
      v-show="inPreview"
      :inPreview="inPreview"
      :generatingPreview="generatingPreview"
      :saving="saving"
      :pdfUrl="pdfUrl"
      :backToForm="backToForm"
      :save="save"
    />
    <div v-show="!inPreview">
      <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
        <h2 class="mb-10">Oficio</h2>
        <div class="row form-group">
          <label for="sender" class="col-3 col-form-label">De</label>
          <span v-html="required('sender')"/>
          <div class="col-4">
            <list-user
              autocomplete
              class="w-100"
              data-cy="sender"
              data-vv-as="DE"
              name="sender"
              label=""
              placeholder="Selecciona un usuario"
              v-model="formData.sender"
              :danger="errors.has('custom-document.sender')"
              :danger-text="errors.first('custom-document.sender')"
              v-validate="'required'"
              @full-user="addUserData"
              ref="sender"
            />
          </div>
        </div>
        <div class="row form-group">
          <label for="senderPosition" class="col-3 col-form-label">Cargo</label>
          <span v-html="required('senderPosition')"/>
          <div class="col-4">
            <b-form-input
              data-cy="senderPosition"
              data-vv-as="cargo"
              name="senderPosition"
              type="text"
              :state="errors.has('custom-document.senderPosition') ? false : null"
              :danger="errors.has('custom-document.senderPosition')"
              :danger-text="errors.first('custom-document.senderPosition')"
              v-validate="'required'"
              v-model="formData.senderPosition"
            />
            <div
              v-if="errors.has('custom-document.senderPosition')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.senderPosition') }}
              </span>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label for="receiver" class="col-3 col-form-label">A</label>
          <div class="col-4">
            <b-form-input
              :state="errors.has('custom-document.receiver') ? false : null"
              data-cy="receiver"
              data-vv-as="A"
              name="receiver"
              type="text"
              v-model="formData.receiver"
            />
            <div
              v-if="errors.has('custom-document.receiver')"
              class="con-text-validation span-text-validation-danger v-enter-to"
            >
              <span class="span-text-validation">
                {{ errors.first('custom-document.receiver') }}
              </span>
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label for="receiverPosition" class="col-3 col-form-label">Cargo</label>
          <div class="col-4">
            <b-form-input
              data-cy="receiverPosition"
              data-vv-as="cargo"
              name="receiverPosition"
              type="text"
              v-model="formData.receiverPosition"
            />
          </div>
        </div>
        <div class="row form-group">
          <label for="receiverPosition" class="col-3 col-form-label">Empresa o municipio</label>
          <div class="col-4">
            <b-form-input
              data-cy="receiverCompany"
              data-vv-as="empresa o municipio"
              name="receiverCompany"
              type="text"
              v-model="formData.receiverCompany"
            />
          </div>
        </div>
        <div class="row form-group">
          <label for="date" class="col-3 col-form-label">Fecha</label>
          <div class="col-4">
            <b-form-group>
              <date-picker
                :class="{
                'w-100': true,
                'danger': $validator.errors.has('date'),
              }"
                data-cy="date"
                name="date"
                data-vv-as="fecha"
                v-model="formData.date"
                format="DD-MM-YYYY"
                value-type="DD-MM-YYYY"
                placeholder="Ej: 30-12-2000"
                v-validate="'required'"
                disabled
                :danger="$validator.errors.has('date')"
              />
              <v-invalid-feedback v-if="$validator.errors.has('date')">
                {{ $validator.errors.first('date') }}
              </v-invalid-feedback>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group label="Ant:">
              <editor-text
                data-cy="background"
                name="background"
                :max-length="500"
                ref="background"
                :toolbar-items="{
                  items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'bold', 'italic',
                    '|', 'insertTable',
                    '|', 'numberedList', 'bulletedList'
                  ]
                }"
                with-counter
                v-model="formData.background"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group label="Materia *">
              <editor-text
                :danger="errors.has('custom-document.matter')"
                :danger-text="errors.first('custom-document.matter')"
                data-cy="matter"
                data-vv-as="materia"
                name="matter"
                :max-length="500"
                ref="matter"
                :toolbar-items="{
                  items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'bold', 'italic',
                    '|', 'insertTable',
                    '|', 'numberedList', 'bulletedList'
                  ]
                }"
                v-validate="'required'"
                with-counter
                v-model="formData.matter"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-form-group label="Descripción *">
              <editor-text
                :danger="errors.has('custom-document.description')"
                :danger-text="errors.first('custom-document.description')"
                data-cy="description"
                data-vv-as="descripción"
                :max-length="maxLengthDescription"
                name="description"
                ref="description"
                v-validate="'required'"
                :toolbar-items="{
                  items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'bold', 'italic',
                    '|', 'insertTable',
                    '|', 'numberedList', 'bulletedList'
                  ]
                }"
                v-model="formData.description"
                with-counter
              />
            </b-form-group>
          </div>
          <div class="col-md-6 mt-2">
            Visadores del proceso
            <span class='text-danger'><b>*</b></span>
            <list-user
              is-multiple
              autocomplete
              class="w-100"
              data-cy="visators"
              data-vv-as="visadores"
              name="visators"
              label=""
              placeholder="Selecciona los visadores"
              :danger="visatorsError !== ''"
              :danger-text="visatorsError"
              @full-user="setInitials"
              ref="visators"
            />
          </div>
          <div class="col-md-6 mt-2">
            Distribución interna
            <v-select
              v-model="formData.directions"
              :options="directions"
              name="directions"
              label="label"
              data-cy="directions"
              placeholder="Selecciona la/s direccion/es"
              multiple
              @input="searchUnits"
            >
              <template slot="no-options">
                no hay direcciones
              </template>
            </v-select>
            <div class="mt-2">
              <b-form-checkbox
                :disabled="!directions.length"
                data-cy="select-all"
                class="d-inline-block"
                v-model="selectAllDirections"
                @change="selectDirections(selectAllDirections)"
              >
              </b-form-checkbox>
              Seleccionar todas
            </div>
          </div>
          <div class="col-md-6 mt-2" v-if="formData.directions.length">
            Unidad
            <v-select
              v-model="formData.units"
              :options="units"
              name="units"
              label="label"
              data-cy="units"
              placeholder="Selecciona la/s unidad/es"
              multiple
            >
              <template slot="no-options">
                no hay unidades
              </template>
            </v-select>
            <div class="mt-2">
              <b-form-checkbox
                :disabled="!units.length"
                data-cy="select-all"
                class="d-inline-block"
                v-model="selectAllUnits"
                @change="selectUnits(selectAllUnits)"
              >
              </b-form-checkbox>
              Seleccionar todas
            </div>
          </div>
          <div class="col-md-12 mt-2">
            <b-form-group label="Distribución externa">
              <editor-text
                :danger="errors.has('custom-document.externalDistribution')"
                :danger-text="errors.first('custom-document.externalDistribution')"
                data-cy="externalDistribution"
                data-vv-as="distribución externa"
                :max-length="maxLengthMatter"
                name="externalDistribution"
                ref="externalDistribution"
                :toolbar-items="{
                  items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'bold', 'italic',
                    '|', 'insertTable',
                    '|', 'numberedList', 'bulletedList'
                  ]
                }"
                v-model="formData.externalDistribution"
                with-counter
              />
            </b-form-group>
          </div>
          <div class="col-md-12">
            <div class="row align-items-center mt-5">
              <div class="col-md-12">
                <label>Adjuntos</label>
              </div>
              <div class="col-md-3 align-items-end">
                <UploadFile
                  permission="*"
                  accept="application/pdf, .doc, .docx, .xlsx, .ppt"
                  text="Seleccionar documentos"
                  v-model="fileOthers"
                  upload-to="ed"
                  :button-class="{ 'btn-block': true,
                  'mb-5': errors.has('custom-document.fileName') }"
                  container-class="w-100"
                  @input="addOthersFile()"
                />
              </div>
            </div>
            <div class="row align-items-center mt-1">
              <div class="col-md-3 align-items-end">
                <b-button
                  variant="secondary"
                  class="btn-icon mt-1"
                  data-cy= "from-repository"
                  v-has-permission="'ED060'"
                  v-b-modal="'add-file-repository'"
                >
                  <feather-icon icon="ServerIcon"/>
                  Desde el repositorio
                </b-button>
              </div>
              <div class="col-2" v-for="file in formData.attachments" :key="file.id">
                <div class="d-flex flex-column align-items-center">
                  <vs-icon icon="description" size="25px" color="primary" />
                  <b class="text-truncate w-100 text-center">{{ file.name }}</b>
                  <vs-button
                    color="danger"
                    type="flat"
                    icon="clear"
                    @click="removeOthersFile(file.id)"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="!!error.messageOthers"
              class="con-text-validation span-text-validation-danger
          vs-input--text-validation-span v-enter-to text-left"
            >
            <span class="span-text-validation">
              {{ error.messageOthers }}
            </span>
            </div>
          </div>
        </div>
        <div class="row justify-end">
          <vs-button
            class="mt-5 mr-5"
            data-cy="cancel"
            @click="back()"
            color="primary"
            :disabled="saving"
          >
            Cancelar
          </vs-button>
          <vs-button
            class="mt-5 mr-5"
            data-cy="preview"
            @click="preview"
            color="warning"
            :disabled="saving"
          >
            Previsualizar
            <span v-show="saving" class="spinner-border spinner-border-sm text-primary" />
          </vs-button>
          <vs-button
            class="mt-5 mr-5"
            data-cy="save"
            @click="save()"
            color="success"
            :disabled="saving"
          >
            Crear
            <span
              v-show="saving"
              class="spinner-border spinner-border-sm text-primary"
            />
          </vs-button>
        </div>
        <!--<SelectDocRepository
          :add-file="addFileRepo"
          :files="formData.attachments"
          :remove-file="removeOthersFile"
        />-->
        <repository-selector
          modal-id="add-file-repository"
          :add-file="addFileRepo"
          :files="formData.attachments"
          :remove-file="removeOthersFile"
        />
      </form>
    </div>
  </div>
</template>
<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import ListUser from '@/febos/chile/lists/components/ListUser';
import FindCodeGroupMixin
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/FindCodeGroupMixin';
import EditorText from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/EditorText';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import SelectDocRepository
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocRepository';
import RepositorySelector from "@/febos/global/customDocuments/components/repository-selector/RepositorySelector.vue";
import VInvalidFeedback from "@/febos/global/customDocuments/components/VInvalidFeedback.vue";
import {mapActions, mapGetters} from "vuex";
import { ioCompanyGroups } from "@/febos/servicios/api/empresas.api";
import FormActionButtons
  from "@/febos/global/customDocuments/vistas/empresas/61980520-8/components/FormActionButtons.vue";
import PdfPreview from "@/febos/global/customDocuments/vistas/empresas/61980520-8/components/PdfPreview.vue";

export default {
  name: 'OF',
  components: {
    PdfPreview,
    FormActionButtons,
    VInvalidFeedback,
    RepositorySelector,
    SelectDocRepository,
    UploadFile,
    ListUser,
    EditorText,
    DatePicker
  },
  mixins: [FindCodeGroupMixin],
  data() {
    return {
      error: {
        messageOthers: ''
      },
      directions: [],
      units: [],
      user: undefined,
      inPreview: false,
      saving: false,
      generatingPreview: false,
      pdfUrl: '',
      selectAllDirections: false,
      selectAllUnits: false,
      formData: {
        orientation: 'Portrait',
        directions: [],
        units: [],
        visators: [],
        visatorsInitials: '',
        sender: '',
        senderPosition: '',
        receiver: '',
        receiverPosition: '',
        receiverCompany: '',
        matter: '',
        background: '',
        description: '',
        externalDistribution: '',
        date: (() => {
          const d = new Date();
          const day = String(d.getDate()).padStart(2, '0');
          const month = String(d.getMonth() + 1).padStart(2, '0');
          return `${day}-${month}-${d.getFullYear()}`;
        })(),
        attachments: []
      },
      fileOthers: {},
      visatorsError: '',
      selectedVisators: [],
      maxLengthDescription: 100000,
      maxLengthMatter: 100000
    };
  },
  computed: {
    ...mapGetters('Usuario', ['currentUser']),
    ...mapGetters('List', [
      'groupsState'
    ]),
    ...mapGetters('Empresas', [
      'empresa',
    ])
  },
  methods: {
    ...mapActions('List', [
      'fetchGroups'
    ]),
    async searchUnits(directions) {
      const directionsId = directions.map((dir) => dir.id).join(',');
      const { data } = await ioCompanyGroups({
        empresaId: this.empresa.id,
        filtros: `padreId:${directionsId}`
      });
      this.units = data.grupos.map((group) => ({
        ...group,
        id: group.id,
        label: group.nombre,
        value: group.id,
      }));
    },
    required(fieldName) {
      const item = this.$validator.fields.items.find((_item) => _item.name === fieldName);
      if (!item || !item.rules || !Object.keys(item.rules).length || !Object.keys(item.rules).includes('required')) {
        return '';
      }
      return "<span class='text-danger'><b>*</b></span>";
    },
    selectDirections(selectAll) {
      if (selectAll) {
        this.searchUnits(this.directions);
        this.formData.directions = [...this.directions];
      } else {
        this.formData.directions = [];
        this.formData.units = [];
      }
    },
    selectUnits(selectAll) {
      if (selectAll) {
        this.formData.units = [...this.units];
      } else {
        this.formData.units = [];
      }
    },
    setInitials(users) {
      if (!users || !users.length) {
        this.formData.visatorsInitials = '';
        this.formData.visators = [];
        this.selectedVisators = [];
        return;
      }
      this.selectedVisators = users;
      this.formData.visators = users;
      this.visatorsError = '';
      this.formData.visatorsInitials = users
        .map((u) => u.label.split(' ').map((word) => word.charAt(0).toUpperCase()).join(''))
        .join(', ');
    },
    addUserData(user) {
      this.user = user;
      this.formData.senderPosition = user.position;
    },
    async addFileRepo(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.formData.attachments.push(file);
      this.error.message = '';
    },
    async addOthersFile() {
      if (!Object.keys(this.fileOthers).length) {
        return;
      }

      if (this.fileOthers.failed) {
        this.error.messageOthers = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.formData.attachments.push(this.fileOthers);
      this.error.messageOthers = '';
    },
    removeOthersFile(fileId) {
      this.formData.attachments = this.formData.attachments
        .filter((file) => file.id !== fileId);
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    backToForm() {
      this.inPreview = false;
    },
    async save() {
      const isValid = await this.validateForm('custom-document');
      // eslint-disable-next-line no-console
      if (!this.selectedVisators.length) {
        this.visatorsError = 'El campo visadores es obligatorio';
      }
      if (!isValid || !this.selectedVisators.length) {
        return;
      }

      const textPlainExternalDistribution = this.$refs.externalDistribution.getTextPlain();
      const textPlainDescription = this.$refs.description.getTextPlain();
      const textPlainBackground = this.$refs.background.getTextPlain();
      const textPlainMatter = this.$refs.matter.getTextPlain();

      if (textPlainDescription.length > this.maxLengthDescription) {
        this.$bvToast.toast(
          'El campo descripción tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      if (textPlainBackground.length > 500) {
        this.$bvToast.toast(
          'El campo antecedentes tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      if (textPlainMatter.length > 500) {
        this.$bvToast.toast(
          'El campo materia tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      if (textPlainExternalDistribution.length > this.maxLengthMatter) {
        this.$bvToast.toast(
          'El campo distribución externa tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      this.$bvToast.toast(
        'Guardando documento',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      try {
        const payload = {
          type: this.$route.params.type,
          query: this.$route.query,
          formData: {
            ...this.formData,
            requesterInitials: this.currentUser.nombre.split(' ').map((word) => word.charAt(0).toLowerCase()).join(''),
            sender: {
              ...this.$refs.sender.getOption(),
              position: this.formData.senderPosition
            },
            background: this.formData.background.replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/gi, ''),
            matter: this.formData.matter.replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/gi, ''),
            description: this.formData.description.replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/gi, ''),
            textPlainExternalDistribution,
            textPlainDescription,
            textPlainBackground,
            textPlainMatter,
            metadata: { orientation: this.formData.orientation }
          }
        };
        this.saving = true;
        const response = await ioCreateCustomDocument(payload);
        await this.generatePdf(response.data.document.id);
      } catch (error) {
        this.$bvToast.toast(
          'Error al guardar el documento, inténtalo de nuevo',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        console.log(error);
      } finally {
        this.saving = false;
      }
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      try {
        const response = await ioGetCustomDocument('OF', id, { pdf: 'si' });
        this.$bvToast.toast(
          'Archivo generado',
          {
            title: 'Listo!',
            variant: 'success',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        window.open(response.data.pdf, '_blank');
        this.back();
      } catch (error) {
        this.$bvToast.toast(
          'Error al generar el PDF, inténtalo de nuevo',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
      }
    },
    async preview() {
      const isValid = await this.validateForm('custom-document');
      // eslint-disable-next-line no-console
      if (!this.selectedVisators.length) {
        this.visatorsError = 'El campo visadores es obligatorio';
      }
      if (!isValid || !this.selectedVisators.length) {
        return;
      }

      this.pdfUrl = '';
      const textPlainExternalDistribution = this.$refs.externalDistribution.getTextPlain();
      const textPlainDescription = this.$refs.description.getTextPlain();
      const textPlainBackground = this.$refs.background.getTextPlain();
      const textPlainMatter = this.$refs.matter.getTextPlain();
      if (textPlainDescription.length > this.maxLengthDescription) {
        this.$bvToast.toast(
          'El campo descripción tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      if (textPlainBackground.length > 500) {
        this.$bvToast.toast(
          'El campo antecedentes tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      if (textPlainMatter.length > 500) {
        this.$bvToast.toast(
          'El campo materia tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      if (textPlainExternalDistribution.length > this.maxLengthMatter) {
        this.$bvToast.toast(
          'El campo distribución externa tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }
      try {
        this.$bvToast.toast(
          'Generando previsualización',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 3000
          }
        );
        this.inPreview = true;
        this.generatingPreview = true;
        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            simular: 'si',
          },
          formData: {
            ...this.formData,
            requesterInitials: this.currentUser.nombre.split(' ').map((word) => word.charAt(0).toLowerCase()).join(''),
            sender: {
              ...this.$refs.sender.getOption(),
              position: this.formData.senderPosition
            },
            textPlainExternalDistribution,
            textPlainDescription,
            description: this.formData.description.replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/gi, ''),
            background: this.formData.background.replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/gi, ''),
            matter: this.formData.matter.replace(/<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>/gi, ''),
            textPlainBackground,
            textPlainMatter,
            metadata: { orientation: this.formData.orientation },
            borrador: true,
          }
        };

        const { data: { pdf } } = await ioCreateCustomDocument(payload);

        if (!pdf || pdf === '') {
          this.$bvToast.toast(
            'Ups!',
            {
              title: 'No se pudo generar la previsualización',
              variant: 'warning',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 5000
            }
          );
          this.backToForm();
        }

        this.pdfUrl = `${pdf}#toolbar=0&navpanes=0&scrollbar=0`;
      } finally {
        this.generatingPreview = false;
      }
    },
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    }
  },
  async created() {
    await this.fetchGroups();
    this.directions = this.groupsState.list.filter((group) => group.padreId === '' || !group.padreId);
  },
};
</script>
